/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';

	const goodsModal = ()=> {
		console.log('goodsModal');
		$('.volunteer-goods-modal-img').on('click', (e) => {
			const $overlay = $(e.currentTarget).parent().next('.mod-modal-overlay')
			console.log($overlay);
			$overlay.addClass(a);
			setTimeout(() => {
				$overlay.addClass(v);
				$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', () => {
					$overlay.removeClass(v);
					setTimeout(() => {
						$overlay.removeClass(a);
					}, 400);
				});
			});
		});
	}

	goodsModal();


})(window.jQuery, window.FUNCTIONS);
